import { AxiosResponse } from "axios";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react"
import * as mb from "../../../common/MessageBox";
import { getCart} from "views/utils/CartFunc";
import { IFCart} from "views/utils/CommonConst";
import { CtxOrder } from "views/utils/Contexts";
import { numberToPrice, priceToNumber, reloadBlock, scrollTop, sendWindowHeight, string8ToFormatDateString} from "views/utils/CommonFunc";
import {postApiDataWithToken} from "views/utils/CallApi";
import { useHistory } from "react-router-dom";
import { Error } from "views/guest/pages/error/Error";
import { MultiLine } from "views/common/MultiLine";
export interface IFParamService {
    service_id: string,
    service_quantity: number,
    option_list: {
        option_id: string,
        option_quantity: number
    }[],
}

export function Confirm(): JSX.Element{

    const history = useHistory();
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [sumPrice, setSumPrice] = useState("");
    const [parkingSpace, setParkingSpace] = useState("");
    const [firstTime, setFirstTime] = useState("");
    const order = useContext(CtxOrder);
    const cart:IFCart[] = getCart();
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const [loadErr, setLoadErr] = useState("");
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){

        scrollTop();

        //カート画面を経由していない（ゲスト用セッションがない）場合、エラー
        if (!window.sessionStorage.getItem("guest_access_token")){
            setLoadErr("token_error");
            return;
        }

        //注文フォーム情報が使用開始していない場合（リロードされた場合）、エラー
        if (order.data.initial){
            setLoadErr("reload_error");
            return;
        }

        //合計金額計算
        let tmpSum = 0;
        cart.forEach(function(service){
            
            service.option_list.forEach(function(option){
                tmpSum += priceToNumber(option.option_price) * option.option_count;
            });
            tmpSum += priceToNumber(service.service_price) * service.service_count;
        });
        setSumPrice(numberToPrice(tmpSum));

        //選択項目の設定
        if(order.data.parking_space_flg === "0"){
            setParkingSpace("あり");
        }else if(order.data.parking_space_flg === "1"){
            setParkingSpace("近くに有料のパーキングあり");
        }else if(order.data.parking_space_flg === "2"){
            setParkingSpace("なし");
        }

        if(order.data.first_time_flg === "0"){
            setFirstTime("はじめて");
        }else if(order.data.first_time_flg === "1"){
            setFirstTime("2回目以降");
        }  

        //ウィンドウサイズを呼び出し元に渡す
        sendWindowHeight(refWindow);

        //リロード制御
        window.addEventListener('beforeunload', reloadBlock);
        return function(){
            window.removeEventListener('beforeunload', reloadBlock);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    //-------------------------------------
    //確定ボタン
    //-------------------------------------
    function clickRegister(){       
        setSubmitDisabled(true);

        //セッションからカート情報を取得
        let tmpCart:IFCart[] = getCart();
        let tmpParamService:IFParamService[] =[];
        tmpCart.forEach(function(service){
            let paramOptions:any = [];

            service.option_list.forEach(function(option){
                paramOptions.push({
                    option_id: option.option_id,
                    option_quantity: option.option_count
                });
            });

            tmpParamService.push({
                service_id: service.service_id,
                service_quantity: service.service_count,
                option_list: paramOptions,
            });

        });

        //メール本文作成
        let message = order.data.order_name_last + " " + order.data.order_name_first + "様\r\n"
        message += "お申込番号：\r\n\r\n"
        message += "仮予約氏名：" + order.data.order_name_last + " " + order.data.order_name_first + "\r\n"
        message += "仮予約日時：\r\n"
        message += "　　・第一希望：" + string8ToFormatDateString(order.data.reserve_date_1) + order.data.reserve_start_time_1.slice( 0, -3 ) + " ～ " + order.data.reserve_end_time_1.slice( 0, -3 ) + "\r\n"
        if (order.data.reserve_date_2 !== "" && order.data.reserve_date_2 !== undefined){
            message += "　　・第二希望：" + string8ToFormatDateString(order.data.reserve_date_2) + order.data.reserve_start_time_2.slice( 0, -3 ) + " ～ " + order.data.reserve_end_time_2.slice( 0, -3 ) + "\r\n"
        }
        if (order.data.reserve_date_3 !== "" && order.data.reserve_date_3 !== undefined){
            message += "　　・第三希望：" + string8ToFormatDateString(order.data.reserve_date_3) + order.data.reserve_start_time_2.slice( 0, -3 ) + " ～ " + order.data.reserve_end_time_3.slice( 0, -3 ) + "\r\n"
        }
        message += "予約内容\r\n" 
        cart.forEach(service => {
            message += "　　サービス　：　" + service.service_name + "\r\n"
            service.option_list.forEach(function( option, ind){
                if(ind === 0){
                    message += "　　オプション：　" + option.option_name + "\r\n"
                }else{
                    message += "　　　　　　　　　" + option.option_name + "\r\n"
                }
            })
            message += "\r\n"
        });
        message += "料金：" + sumPrice + "（税込）\r\n\r\n"
        message += "※当日、追加メニューをご利用された場合は金額が変更となります。\r\n※お支払いは、現金、クレジットカード決済、キャッシュレス決済がご利用いただけます。\r\n"
        message += "上記、内容にて予約が確定次第、メール又はお電話にて\r\n折り返しこちらからご連絡させていただきます。"
        message += "お時間いただけますして大変恐縮ではございますが、\r\n何卒宜しくお願い致します。"

        //お申込み情報登録
        postApiDataWithToken('/cart/order-application',
        {
            billing_price: priceToNumber(sumPrice),
            order_name: order.data.order_name_last + " " + order.data.order_name_first,
            furigana: order.data.furigana_last + " " + order.data.furigana_first,
            zip: order.data.zip,
            address: order.data.address_first + order.data.address_second + order.data.address_thirs + order.data.address_fourth,
            phone: order.data.phone,
            email_address: order.data.email_address,
            parking_space_flg: order.data.parking_space_flg,
            first_time_flg: order.data.first_time_flg,
            order_comment: order.data.order_comment,
            reserve_date_1: order.data.reserve_date_1,
            reserve_date_2: order.data.reserve_date_2,
            reserve_date_3: order.data.reserve_date_3,
            reserve_date_start_1: order.data.reserve_start_time_1,
            reserve_date_start_2: order.data.reserve_start_time_2,
            reserve_date_start_3: order.data.reserve_start_time_3,
            reserve_date_end_1: order.data.reserve_end_time_1,
            reserve_date_end_2: order.data.reserve_end_time_2,
            reserve_date_end_3: order.data.reserve_end_time_3,
            order_service_list: tmpParamService,
            mail_message: message
        },
        window.sessionStorage.getItem("guest_access_token"),
        function(res:AxiosResponse<any>){
            switch (res.status) {
                case 200:
                case 401:
                    //登録、メール送信が完了後、画面遷移
                    history.push("/guest/complete?orderNo=" + res.data.order_no);
                    break;
                default:
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"申込処理に失敗しました。大変お手数をおかけいたしますが、時間をおいて再度操作していただくか、直接お電話にてお問い合わせください。"});
            }
        });
        setSubmitDisabled(false);
    }

    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <div className="order-main" ref={refWindow}>
                <mb.MessageBox args={msgArgs}/> 
                <div className="order-width-max">
                <div className="order-box">
                    <div className="order-flow">
                    <ul className="order-flow-list">
                        <li className="is-past">見積内容の確認</li>
                        <li className="is-past">希望日時の選択</li>
                        <li className="is-past">申込情報の入力</li>
                        <li className="is-current">申込内容の確認</li>
                        <li>申込完了</li>
                    </ul>
                    </div>
                    <div className="order-form">
                    <div className="order-form-title">お見積り内容の詳細</div>
                        {cart?.map(function(service, index){
                            return(
                                <div key={index} className="order-cart-item">
                                {service.service_image &&
                                <div className="order-cart-item-img">
                                    {service.service_url ? <a href={service.service_url} target="_blank"><img src={service.service_image}/></a> : <img src={service.service_image}/>}
                                </div>
                                }
                                <ul className={service.service_image ? "order-cart-item-list" : "order-cart-item-list no-img"}>
                                <li className="service">
                                    <div className="order-cart-item-text">
                                    <div className="order-cart-item-title">
                                        {service.service_url ? <a href={service.service_url} target="_blank">{service.service_name}</a> : service.service_name}
                                    </div>
                                    <div className="order-cart-item-price">価格：<span className="text-weight-bold">{service.service_price}</span>(税込)</div>
                                    </div>
                                    <div className="order-cart-item-control">{service.service_count}{service.service_unit}</div>
                                </li>
                                    {service.option_list?.map(function(option, idx){
                                        return(
                                            <li key={idx}className="option">
                                            <div className="order-cart-item-text">
                                            <div className="order-cart-item-title">{option.option_name}</div>
                                            <div className="order-cart-item-price">価格：<span className="text-weight-bold">{option.option_price}</span>(税込)</div>
                                            </div>
                                            <div className="order-cart-item-control">{option.option_count}</div>
                                            </li>
                                        )
                                    })}
                                </ul>
                                </div>
                            )
                        })}
                    <div className="order-form-sum order-form-sum-detail">お見積り合計金額　<span className="text-size-ll text-weight-bold text-color-blue">{sumPrice}</span> （税込）</div>
                    </div>
                    <div className="order-form order-form-confirm">
                    <div className="order-form-title">
                        サービス実施希望日
                    </div>
                    <div className="order-select-date">
                        <ul className="order-select-date-list">
                        <li>
                            <div className="order-select-date-title">第1希望</div>
                            <div className="order-select-date-datetime">
                            <div>
                                <p className="date">{string8ToFormatDateString(order.data.reserve_date_1)}</p>
                                <p className="time">{order.data.reserve_start_time_1.slice( 0, -3 )} - {order.data.reserve_end_time_1.slice( 0, -3 )}</p>
                            </div>
                            </div>
                        </li>
                        <li>
                            <div className="order-select-date-title">第2希望</div>
                            {(() => {
                                if (order.data.reserve_date_2 !== "" && order.data.reserve_date_2 !== undefined){return(
                                    <div className="order-select-date-datetime">
                                    <div>
                                        <p className="date">{string8ToFormatDateString(order.data.reserve_date_2)}</p>
                                        <p className="time">{order.data.reserve_start_time_2.slice( 0, -3 )} - {order.data.reserve_end_time_2.slice( 0, -3 )}</p>
                                    </div>
                                    </div>
                                )}else{return(
                                    <div className="order-select-date-datetime">
                                    なし
                                    </div>
                                )
                            }})()}
                        </li>
                        <li>
                            <div className="order-select-date-title">第3希望</div>
                            {(() => {
                                if (order.data.reserve_date_3 !== "" && order.data.reserve_date_3 !== undefined){return(
                                    <div className="order-select-date-datetime">
                                    <div>
                                        <p className="date">{string8ToFormatDateString(order.data.reserve_date_3)}</p>
                                        <p className="time">{order.data.reserve_start_time_3.slice( 0, -3 )} - {order.data.reserve_end_time_3.slice( 0, -3 )}</p>
                                    </div>
                                    </div>
                                )}else{return(
                                    <div className="order-select-date-datetime">
                                    なし
                                    </div>
                                )
                            }})()}
                        </li>
                        </ul>
                    </div>
                    </div>
                    <div className="order-form order-form-confirm">
                    <div className="order-form-title">
                        お申込情報
                    </div>
                    <div className="form-row">
                        <div className="control-horizon">
                        <div style={{width: "50%"}}>
                            <div className="form-row-title">姓</div>
                            <div className="form-row-input">{order.data.order_name_last}</div>
                        </div>
                        <div style={{width: "50%"}}>
                            <div className="form-row-title">名</div>
                            <div className="form-row-input">{order.data.order_name_first}</div>
                        </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="control-horizon">
                        <div style={{width: "50%"}}>
                            <div className="form-row-title">せい（ふりがな）</div>
                            <div className="form-row-input">{order.data.furigana_last}</div>
                        </div>
                        <div style={{width: "50%"}}>
                            <div className="form-row-title">めい（ふりがな）</div>
                            <div className="form-row-input">{order.data.furigana_first}</div>
                        </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">郵便番号</div>
                        <div className="form-row-input">{order.data.zip}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">ご住所</div>
                        <div className="form-row-input">{order.data.address_first}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">市区町村</div>
                        <div className="form-row-input">{order.data.address_second}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">町名・番地</div>
                        <div className="form-row-input">{order.data.address_thirs}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">建物名・号室</div>
                        <div className="form-row-input">{order.data.address_fourth}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">電話番号</div>
                        <div className="form-row-input">{order.data.phone}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">メールアドレス</div>
                        <div className="form-row-input">{order.data.email_address}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">駐車スペースの有無</div>
                        <div className="form-row-input">{parkingSpace}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">弊社サービスのご利用について</div>
                        <div className="form-row-input">{firstTime}</div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">ご要望・ご質問等</div>
                        <div className="form-row-input">
                        <MultiLine val={order.data.order_comment}/>
                        </div>
                    </div>
                    </div>
                    <div className="form-row control-horizon control-between">
                    <button className="btn-order btn-secondary btn-icon-left" onClick={function(){history.push("/guest/guestinfo")}}><span className="icon material-icons-round md-18">arrow_back</span>申込情報の入力へ戻る</button>
                    <button className="btn-order btn-primary btn-icon-right" onClick={clickRegister} disabled={submitDisabled}>申込内容の確定<span className="icon material-icons-round md-18">arrow_forward</span></button>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}